import { API_BASE_URL } from '../config';

class GoogleCalendarService {
  /**
   * Synchronize a Google Calendar with a space
   * @param {string} token - Authentication token
   * @param {Object} data - { calendar_id: string, place_id: string }
   * @returns {Promise<Object>} - Response data
   */
  static async calendarSync(token, data) {
    try {
      const response = await fetch(`${API_BASE_URL}googlecalendar?calendar_id=${data.calendar_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw {
          status: response.status,
          data: errorData
        };
      }

      return await response.json();
    } catch (error) {
      console.error('Calendar sync failed:', error);
      throw {
        status: error.status || 500,
        data: error.data || { 
          success: false,
          errors: [{ message: 'Network error or server unavailable' }]
        }
      };
    }
  }

  /**
   * Desynchronize a Google Calendar
   * @param {string} token - Authentication token
   * @param {string} calendarId - Google Calendar ID to desynchronize
   * @returns {Promise<Object>} - Response data
   */
  static async calendarDesync(token, calendarId) {
    try {
      const response = await fetch(`${API_BASE_URL}googlecalendar/disassociate/${calendarId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw {
          status: response.status,
          data: errorData
        };
      }

      return await response.json();
    } catch (error) {
      console.error('Calendar desync failed:', error);
      throw {
        status: error.status || 500,
        data: error.data || {
          success: false,
          errors: [{ message: 'Network error or server unavailable' }]
        }
      };
    }
  }

  /**
   * Get custom pages (maintained for backward compatibility)
   * @returns {Promise<Object>} - Response data
   */
  static async getCustomPages() {
    try {
      const response = await fetch(`${API_BASE_URL}custom_pages`);
      
      if (!response.ok) {
        throw {
          status: response.status,
          data: await response.json()
        };
      }
      
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch custom pages:', error);
      throw {
        status: error.status || 500,
        data: error.data || {
          success: false,
          errors: [{ message: 'Failed to load custom pages' }]
        }
      };
    }
  }
}

export default GoogleCalendarService;